webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(219);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(250), __esModule: true };

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(275);
	module.exports = __webpack_require__(15).Object.keys;


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(67);
	var $keys = __webpack_require__(47);
	
	__webpack_require__(152)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = exports.replace = exports.push = undefined;
	
	var _extends2 = __webpack_require__(139);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(239);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(140);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(45);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(64);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(63);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(81);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	/* eslint-disable react/no-deprecated */
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___push(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	/* eslint-enable */
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var push = exports.push = function push(to) {
	  window.___push(to);
	};
	
	var replace = exports.replace = function replace(to) {
	  window.___replace(to);
	};
	
	var navigateTo = exports.navigateTo = push;

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  max-width: 1366px;\n  padding: 1rem 1rem;\n"], ["\n  margin: 0 auto;\n  max-width: 1366px;\n  padding: 1rem 1rem;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: 1rem 0;\n  font-size: calc(1.5vw + 1.5vh + 0.3vmin);\n  ", ";\n"], ["\n  margin: 1rem 0;\n  font-size: calc(1.5vw + 1.5vh + 0.3vmin);\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["margin: 0 auto; padding-bottom: 40px;text-align:center; font-size: calc(2.0vw + 2.0vh + 0.9vmin); margin: 0"], ["margin: 0 auto; padding-bottom: 40px;text-align:center; font-size: calc(2.0vw + 2.0vh + 0.9vmin); margin: 0"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  text-decoration: none;\n  &:hover {\n    color: #d8cd1f;\n  }\n  ", ";\n"], ["\n  color: #fff;\n  text-decoration: none;\n  &:hover {\n    color: #d8cd1f;\n  }\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["&:hover {\n    color: #fff;\n  }"], ["&:hover {\n    color: #fff;\n  }"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  background: hsl(136, 100%, 23%);\n  box-shadow: 1px 2px 7px #666;\n  top: 0;\n  z-index: 1;\n  position: sticky;\n  ", ";\n"], ["\n  background: hsl(136, 100%, 23%);\n  box-shadow: 1px 2px 7px #666;\n  top: 0;\n  z-index: 1;\n  position: sticky;\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["top: -50px"], ["top: -50px"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(217);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _gatsbyLink = __webpack_require__(171);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(24);
	
	var _styleUtils2 = _interopRequireDefault(_styleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var H1 = _styledComponents2.default.h1(_templateObject2, _styleUtils2.default.phone(_templateObject3));
	var H1Link = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, _styleUtils2.default.phone(_templateObject5));
	
	var Background = _styledComponents2.default.div(_templateObject6, _styleUtils2.default.phone(_templateObject7));
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      Background,
	      null,
	      _react2.default.createElement(
	        Container,
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "four columns" },
	            _react2.default.createElement(
	              H1,
	              null,
	              _react2.default.createElement(
	                H1Link,
	                { to: "/" },
	                "Science Roadshows"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "eight columns" },
	            _react2.default.createElement(_nav2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 1rem;\n  color: #fff;\n  text-decoration: none;\n  font-size: 3rem;\n  font-family: \"comic sans ms\", cursive, sans-serif;\n\n  &:hover {\n    color: #d8cd1f;\n  }\n  .is-active {\n    color: #d8cd1f;\n  }\n\n  ", ";\n"], ["\n  padding: 1rem;\n  color: #fff;\n  text-decoration: none;\n  font-size: 3rem;\n  font-family: \"comic sans ms\", cursive, sans-serif;\n\n  &:hover {\n    color: #d8cd1f;\n  }\n  .is-active {\n    color: #d8cd1f;\n  }\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["padding: 0; font-size:2rem"], ["padding: 0; font-size:2rem"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleUtils = __webpack_require__(24);
	
	var _styleUtils2 = _interopRequireDefault(_styleUtils);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(171);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, _styleUtils2.default.phone(_templateObject2));
	
	var MainNavLink = function (_React$Component) {
	  _inherits(MainNavLink, _React$Component);
	
	  function MainNavLink() {
	    _classCallCheck(this, MainNavLink);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainNavLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      NavLink,
	      { activeClassName: "is-active", to: this.props.href },
	      this.props.text
	    );
	  };
	
	  return MainNavLink;
	}(_react2.default.Component);
	
	MainNavLink.propTypes = {
	  text: _propTypes2.default.string,
	  href: _propTypes2.default.string
	};
	
	// const MainNavLink = props =>
	// 	<li
	// 		style={{
	
	// 		}}
	// 	>
	// 		{props.text}
	// 	</li>
	
	// ;
	
	exports.default = MainNavLink;
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  margin: 0;\n  ", ";\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin: 0;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["justify-content: space-between;"], ["justify-content: space-between;"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _navLink = __webpack_require__(216);
	
	var _navLink2 = _interopRequireDefault(_navLink);
	
	var _styleUtils = __webpack_require__(24);
	
	var _styleUtils2 = _interopRequireDefault(_styleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MainNavUL = _styledComponents2.default.ul(_templateObject, _styleUtils2.default.phone(_templateObject2));
	
	var MainNav = function (_React$Component) {
		_inherits(MainNav, _React$Component);
	
		function MainNav() {
			_classCallCheck(this, MainNav);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		MainNav.prototype.render = function render() {
			return _react2.default.createElement(
				"nav",
				null,
				_react2.default.createElement(
					MainNavUL,
					null,
					_react2.default.createElement(_navLink2.default, { text: "Schools", href: "/schools" }),
					_react2.default.createElement(_navLink2.default, { text: "Libraries", href: "/libraries" }),
					_react2.default.createElement(
						_navLink2.default,
						{ text: "Contact", href: "/contact" },
						"Contact"
					)
				)
			);
		};
	
		return MainNav;
	}(_react2.default.Component);
	
	exports.default = MainNav;
	module.exports = exports["default"];

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 20px 0px;\n"], ["\n  padding: 20px 0px;\n"]);
	
	__webpack_require__(322);
	
	__webpack_require__(323);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(215);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
		var children = _ref.children;
		return _react2.default.createElement(
			"div",
			null,
			_react2.default.createElement(_reactHelmet2.default, {
				title: "Virtual and Live Science Roadshows by Lee Ognibene",
				meta: [{
					name: "description",
					content: "Virtual and Live programs presented for your School or Library by teacher Lee Ognibene. "
				}, {
					name: "keywords",
					content: "virtual, live, show, science, roadshow, space, forest, rain, teacher, earth, school, library, sea, rainforest, bugs, bee, shark"
				}, {
					name: "google-site-verification",
					content: "98cR6cME9P5bbJUo6MtqyDPx-jM-MDtsU61CfKyiG4o"
				}]
			}),
			_react2.default.createElement(_Header2.default, null),
			_react2.default.createElement(
				"div",
				{
					style: {
						margin: "0 auto",
						maxWidth: 1366,
						padding: "0px 1.0875rem 1.45rem",
						paddingTop: 0
					}
				},
				_react2.default.createElement(
					Container,
					{ className: "container" },
					children()
				)
			)
		);
	};
	
	TemplateWrapper.propTypes = {
		children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "], ["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "]);
	
	var _styledComponents = __webpack_require__(14);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } // these sizes are arbitrary and you can set them to whatever you wish
	
	
	var sizes = {
		giant: 1199,
		desktop: 999,
		tablet: 749,
		phone: 549
	};
	
	var media = Object.keys(sizes).reduce(function (acc, label) {
		acc[label] = function () {
			return (0, _styledComponents.css)(_templateObject, sizes[label], _styledComponents.css.apply(undefined, arguments));
		};
	
		return acc;
	}, {});
	
	exports.default = media;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b8d91023311858bd6b65.js